import { ReportConfiguration } from '@Containers/Report';

const ReportPage: React.FunctionComponent = (): JSX.Element => (
  <ReportConfiguration />
);

export default ReportPage;
